import { ButtonGroup, Dropdown, DropdownButton } from "react-bootstrap";
import React from "react";
import { useGetPossibleLocationsQuery } from "../api/courses";
import { GlgSelect } from "../../shared/components";
import { useDispatch } from "react-redux";
import { setLocation } from "../store/filtersSlice";

export const LocationFilter = () => {
  
  const dispatch = useDispatch()

  const {data: possibleLocations, isLoading} = useGetPossibleLocationsQuery()

  return(
  <>
    <div className="bold">Location</div>
    <GlgSelect
      searchable
      className='courses-filter-dropdown'
      items={possibleLocations || []}
      height={33}
      onChange={(location) => dispatch(setLocation(location))}>
    </GlgSelect>
  </>
  )
};